export default "__VITE_ASSET__0ea1a57a__"